import type {
  ColorProps,
  LayoutProps,
  OpacityProps,
  SpacingProps,
  TextShadowProps,
  TypographyProps,
  VariantProps,
  VisibleProps,
} from '@shopify/restyle';
import {
  color,
  createRestyleComponent,
  createVariant,
  layout,
  opacity,
  spacing,
  textShadow,
  typography,
  visible,
} from '@shopify/restyle';
import type { ComponentProps } from 'react';
import { Component } from 'react';
import type { TextProps } from 'react-native';
import { Text as NativeText } from 'react-native';
import Animated from 'react-native-reanimated';

import { isMobileNative } from 'app/utils/web-helpers';
import type { Theme } from 'app/shopify';

type RestyleProps = ColorProps<Theme> &
  LayoutProps<Theme> &
  OpacityProps<Theme> &
  SpacingProps<Theme> &
  TextShadowProps<Theme> &
  TypographyProps<Theme> &
  VariantProps<Theme, 'textVariants'> &
  VisibleProps<Theme>;

export const Text = createRestyleComponent<RestyleProps & TextProps, Theme>(
  [color, createVariant({ themeKey: 'textVariants' }), layout, opacity, spacing, textShadow, typography, visible],
  NativeText,
);

export const AnimatedText = !isMobileNative
  ? Text
  : Animated.createAnimatedComponent(
      class AnimatedTextComponent extends Component<ComponentProps<typeof Text>> {
        override render() {
          const { key, ...rest } = this.props;
          return <Text {...rest} />;
        }
      },
    );
